import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersRoleplayingConditionMutateType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = ({ id }: RequestDataType) => {
  return new ApiClient()
    .delete<ApiMembersRoleplayingConditionMutateType>(
      `/api/members/roleplaying_conditions/${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersRoleplayingConditionsDestroy = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersRoleplayingConditionMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
